import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';
import { SplitControlsButton } from './SplitControlsButton';

const PREFIX = 'SplitControls';

const classes = {
    counter: `${PREFIX}counter`,
    icon: `${PREFIX}icon`
};

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    [`& .${classes.counter}`]: {
        fontSize: '28px',
        padding: theme.spacing(0, 3)
    },

    [`& .${classes.icon}`]: {
        fontSize: '1rem'
    }
}));

interface SplitControlsProps {
    value: number;
    increase: () => void;
    decrease: () => void;
    max?: number;
    min?: number;
    disable?: boolean;
}

export const SplitControls: React.FC<React.PropsWithChildren<SplitControlsProps>> = ({
    value,
    increase,
    decrease,
    max,
    min,
    disable
}) => (
    <StyledBox>
        <SplitControlsButton onClick={decrease} disabled={disable || value === min}>
            <Remove className={classes.icon} />
        </SplitControlsButton>
        <Typography className={classes.counter}>{value}</Typography>
        <SplitControlsButton onClick={increase} disabled={disable || value === max}>
            <Add className={classes.icon} />
        </SplitControlsButton>
    </StyledBox>
);
